// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Literata:opsz,wght@7..72,600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&family=Literata:opsz,wght@7..72,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    overflow-x: hidden;
}
.bg-gradient-info  {
    background-color: #09173a !important;
}
.btn-primary{
    background-color: #242E4C !important;
    border: none !important;
}
.primary{
    color:#242E4C !important;
}
.card .table td{
    padding-left: 5px !important;
    padding-right: 5px !important;
}
.primary.btn-primary, .btn.btn-primary,.bg-gradient-info{
    background-color:#a88053!important;
}
:global(.bg-gradient-info){
    background-color:#a88053!important;
}
.rrpClass, 
.pagination ul li.active > .page-link
,.pagination ul li.active > .page-link{
    background-color: #2d3248 !important;
}
h1,h2,h3,h4,h5,h6,.media a{
    color: #2d3248 !important;
    font-family: 'Literata', serif !important;
}
body, .footer a,#sidenav-main a{
    color: rgb(35, 33, 46) !important;
}
body{
    font-family: 'DM Sans', sans-serif !important;
}
a:hover,#sidenav-main a:hover,.copyright a{
    color: #893b23 !important;
}
.bg-gradient-default-1 {
    background: linear-gradient(87deg, #172b4d 0, #000000 100%) !important;
}
.nav-link{
font-family: 'Literata', serif !important;
}
.nav-link.active{
color:#a88053;
}
.navbar.spectator-nav .nav-link.active{
color:#a88053 !important;
}
.navbar.spectator-nav{
background-color: #F8F9FE !important;
border-bottom: solid 1px #e8e8e8;
}
@media (min-width: 576px){
.fullscreen-modal {
    max-width: 80% !important;
    margin: 1.75rem auto;
}
}.navbar-horizontal .navbar-brand img {
    height: 60px !important;
}
.step-active{
    background-color: rgb(25, 174, 25) !important;
}
.row button[type=submit].btn.btn-primary{
    width: auto !important;
}
.profile{
    width: 110px !important;
    height: 110px !important;
    object-fit: cover !important;
    border-radius: 50% !important;
}
.next__level_camps_container{
    background: #f8ece4;;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;IACI,kBAAkB;AACtB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;;;IAGI,oCAAoC;AACxC;AACA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;AACA;IACI,iCAAiC;AACrC;AACA;IACI,6CAA6C;AACjD;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sEAAsE;AAC1E;AACA;AACA,yCAAyC;AACzC;AACA;AACA,aAAa;AACb;AACA;AACA,wBAAwB;AACxB;AACA;AACA,oCAAoC;AACpC,gCAAgC;AAChC;AACA;AACA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA,CAAC;IACG,uBAAuB;AAC3B;AACA;IACI,6CAA6C;AACjD;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Literata:opsz,wght@7..72,600&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&family=Literata:opsz,wght@7..72,600&display=swap');\n\nbody {\n    overflow-x: hidden;\n}\n.bg-gradient-info  {\n    background-color: #09173a !important;\n}\n.btn-primary{\n    background-color: #242E4C !important;\n    border: none !important;\n}\n.primary{\n    color:#242E4C !important;\n}\n.card .table td{\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n}\n.primary.btn-primary, .btn.btn-primary,.bg-gradient-info{\n    background-color:#a88053!important;\n}\n:global(.bg-gradient-info){\n    background-color:#a88053!important;\n}\n.rrpClass, \n.pagination ul li.active > .page-link\n,.pagination ul li.active > .page-link{\n    background-color: #2d3248 !important;\n}\nh1,h2,h3,h4,h5,h6,.media a{\n    color: #2d3248 !important;\n    font-family: 'Literata', serif !important;\n}\nbody, .footer a,#sidenav-main a{\n    color: rgb(35, 33, 46) !important;\n}\nbody{\n    font-family: 'DM Sans', sans-serif !important;\n}\na:hover,#sidenav-main a:hover,.copyright a{\n    color: #893b23 !important;\n}\n.bg-gradient-default-1 {\n    background: linear-gradient(87deg, #172b4d 0, #000000 100%) !important;\n}\n.nav-link{\nfont-family: 'Literata', serif !important;\n}\n.nav-link.active{\ncolor:#a88053;\n}\n.navbar.spectator-nav .nav-link.active{\ncolor:#a88053 !important;\n}\n.navbar.spectator-nav{\nbackground-color: #F8F9FE !important;\nborder-bottom: solid 1px #e8e8e8;\n}\n@media (min-width: 576px){\n.fullscreen-modal {\n    max-width: 80% !important;\n    margin: 1.75rem auto;\n}\n}.navbar-horizontal .navbar-brand img {\n    height: 60px !important;\n}\n.step-active{\n    background-color: rgb(25, 174, 25) !important;\n}\n.row button[type=submit].btn.btn-primary{\n    width: auto !important;\n}\n.profile{\n    width: 110px !important;\n    height: 110px !important;\n    object-fit: cover !important;\n    border-radius: 50% !important;\n}\n.next__level_camps_container{\n    background: #f8ece4;;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
